import { Stack, Typography } from "@mui/material"
import { Link } from "react-router-dom"
import { StandardDialog } from "../../../../../shared/components/dialogs/StandardDialog"
import { StandardButton } from "../../../../../shared/components/buttons/StandardButton"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { MESSAGES_ROUTE } from "../../../../../constants/routes"
import { Box } from "@mui/system"
import { Player } from "@lottiefiles/react-lottie-player"
import animation from "../../../../../shared/animations/succeededAnimation.json"
import { makeStyles } from "tss-react/mui"

type CreateMessageSuccessDialogProps = {
    open: boolean
    onClose: () => void
}

const useStyles = makeStyles()((theme) => ({
    animationArea: {
        width: "6rem",
        height: "6rem",
        margin: "0 auto",
        marginBottom: "6rem",
    },
    closeButton: {
        maxWidth: "10rem",
        marginTop: "2.5rem",
    },
    viewArchive: {
        fontSize: "0.938rem",
        lineHeight: "1.625rem",
        textAlign: "center",
        marginBottom: "4rem",
        marginTop: "1rem",
    },
}))

export function CreateMessageSuccessDialog({ open, onClose }: CreateMessageSuccessDialogProps) {
    const { classes } = useStyles()

    const handleViewMessagesClick = () => {
        onClose()
    }

    return (
        <>
            <StandardDialog open={open} onClose={onClose} maxWidthProp="sm">
                <Stack justifyContent="center">
                    <Box className={classes.animationArea}>
                        <Player src={animation} autoplay keepLastFrame />
                    </Box>
                    <LocalizedStrict id="create-message-success-dialog-title">
                        <Typography variant="h6" textAlign="center">
                            Message has been created
                        </Typography>
                    </LocalizedStrict>
                    <Stack direction="row" justifyContent="center" gap="1rem">
                        <LocalizedStrict id="create-message-success-dialog-close-button">
                            <StandardButton className={classes.closeButton} type="button" onClick={onClose}>
                                Close
                            </StandardButton>
                        </LocalizedStrict>
                    </Stack>
                    <LocalizedStrict id="create-message-success-dialog-view-archive">
                        <Link className={classes.viewArchive} to={MESSAGES_ROUTE} onClick={handleViewMessagesClick}>
                            View message archive
                        </Link>
                    </LocalizedStrict>
                </Stack>
            </StandardDialog>
        </>
    )
}
